import { render, staticRenderFns } from "./OrganizationMunicipalityCell.vue?vue&type=template&id=468ed77b&scoped=true&"
import script from "./OrganizationMunicipalityCell.vue?vue&type=script&lang=js&"
export * from "./OrganizationMunicipalityCell.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMunicipalityCell.vue?vue&type=style&index=0&id=468ed77b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ed77b",
  null
  
)

export default component.exports